import { logEvent } from "@api/session";
import { RRQueryClientProvider } from "@components/RRQueryClientProvider";
import { onMount } from "solid-js";
import { CurrentEventSeasonLeaderboard } from "./Leaderboards/CurrentEventSeasonLeaderboard";

export const Home = () => {
  onMount(() => {
    logEvent({ eventType: "view" });
  });

  return (
    <RRQueryClientProvider>
      <CurrentEventSeasonLeaderboard />
    </RRQueryClientProvider>
  );
};
